export const TextReviewInteractivityAction = {
  ACCEPT_ALL: 'Accept All',
  REVERT_ALL: 'Revert All',
  RESET_CHANGES: 'Reset Changes',
}
